export enum CompanyRole {
  FUNDRAISER = "FUNDRAISER",
  INVESTOR = "INVESTOR",
}

export type TCompanyResponse = {
  id: string;
  user_id: string;
  role: CompanyRole;
  name: string;
  onboarding_completed: boolean;
  created_at: string;
  updated_at: string;
  sections?: TCompanySection[];
};

export type TCompanyCreateRequestPayload = {
  role: CompanyRole;
  name: string;
};

export type TCompanySectionThread = {
  id: string;
  title?: string | null;
  name?: string | null;
  created_at?: string;
  updated_at?: string;
};

export type TCompanySection = {
  id: string;
  name: string;
  description: string | null;
  role_type: CompanyRole | null;
  order: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  threads: TCompanySectionThread[];
};
